import React from "react";
import { Layout, Typography } from "antd";
import { Outlet } from "react-router-dom";

const { Content, Footer } = Layout;
const { Text } = Typography;
const index = () => {
  return (
    <Layout
      className="site-layout"
      style={{
        marginLeft: 250,
      }}>
      <Content
        style={{
          margin: "20px",
          overflow: "initial",
        }}>
        {<Outlet />}
      </Content>
      <Footer
        style={{
          textAlign: "center",
          backgroundColor: "transparent",
          marginTop: "-32px",
          bottom:'0px',
          position:'relative'
        }}>
        <a href="https://www.spectusinfotech.com/" target="_blank">
          <Text style={{ color: "black",fontFamily:"Milliard" }}>Copyright © 2022</Text>

          <span
            style={{
              color: "#244DA0",
              textDecoration: "none",
              marginLeft: "5px",
            }}>
            Spectus Infotech
          </span>
        </a>
      </Footer>
    </Layout>
  );
};

export default index;
